/* Role checks used across the UI. Mirror the backend's RBAC matrix so
   we don't show buttons/links the API will reject anyway.

   Source of truth is still the backend — these are just UI hints. */

export const ROLES = ["super_admin", "admin", "employee"];

export function isSuperAdmin(role) { return role === "super_admin"; }
export function isAdmin(role)      { return role === "admin"; }
export function isEmployee(role)   { return role === "employee"; }

/* Can `inviter` invite a user with `targetRole`? */
export function canInviteRole(inviter, targetRole) {
  if (inviter === "super_admin") return true;
  if (inviter === "admin") return targetRole === "employee";
  return false;
}

/* Roles the inviter is allowed to choose when sending an invitation. */
export function invitableRoles(inviter) {
  // super_admin is deliberately absent. An invite link is a bearer token
  // sitting in an inbox, which is the wrong way to hand out the highest
  // privilege in the system. The role is granted by promoting an existing
  // user instead. Mirrored server-side in InvitationsService.canInvite —
  // this list only controls what the dropdown offers, and hiding an option
  // does not stop a crafted request.
  if (inviter === "super_admin") return ["admin", "employee"];
  if (inviter === "admin") return ["employee"];
  return [];
}

/* Can `actor` change another user's role? */
export function canChangeRole(actorRole) {
  return actorRole === "super_admin";
}

/* Can `actor` deactivate a user? */
export function canDeactivate(actorRole) {
  return actorRole === "super_admin";
}

/* Pretty label for a role. */
export function roleLabel(role) {
  if (role === "super_admin") return "Super Admin";
  if (role === "admin") return "Admin";
  if (role === "employee") return "Employee";
  return role;
}
